export let PictureMode = /*#__PURE__*/function (PictureMode) {
  PictureMode["FIT_TO_HEIGHT"] = "FIT_TO_HEIGHT";
  PictureMode["FIT_TO_WIDTH"] = "FIT_TO_WIDTH";
  PictureMode["COVER"] = "COVER";
  PictureMode["CONTAIN"] = "CONTAIN";
  return PictureMode;
}({});
//# sourceMappingURL=picture.types.js.map